/* eslint-disable react/jsx-props-no-spreading */
const StepFourIcon = (props) => (
	<svg width={128} height={120} viewBox="0 0 128 120" {...props}>
		<g fill="none" fillRule="evenodd">
			<circle cx="60" cy="60" r="60" fill="#FFF" opacity=".327" />
			<g stroke="#4D3951" strokeWidth="3" transform="translate(38 35)">
				<path
					fill="#FFF"
					d="M19.66 0c4.29 0 7.337 3.453 6.805 7.705L25.03 19.2h16.115c4.544 0 7.26 3.55 6.06 7.947l-3.175 11.64c-1.594 5.846-7.796 10.584-13.858 10.584H19.2c-6.06 0-10.971-4.914-10.971-10.977V24.68c0-2.258 1.364-4.198 3.317-5.037L15.79 2.669C16.158 1.195 17.694 0 19.197 0h.463z"
				/>
				<rect width="8.229" height="27.429" y="19.2" fill="#FFD166" rx="2.743" />
			</g>
			<g transform="translate(88)">
				<circle cx="20" cy="20" r="20" fill="#FFF" />
				<text
					fill="#373737"
					fontFamily="Inter"
					fontSize="24"
					fontWeight="700"
				>
					<tspan x="12.98" y="28">
						4
					</tspan>
				</text>
			</g>
		</g>
	</svg>
);

export default StepFourIcon;
